import i18n from "i18next";
import { Card } from "@/Components/Card";
import Module from "@/Pages/Manage/Module";
import { showChargebeeSection, showChargeBeeUi } from "@/Utilities/ChargeBee";
import FlashMessage from "@/Components/FlashMessage";
import { useState } from "react";
import styles from "@/../sass/components/MyModuleCard.module.scss";

export default function MyModulesCard({ props, state, dispatch }) {
    const statusNames = props.statusNames;

    const [chargebeeErrorMessage, setChargebeeErrorMessage] = useState(null);

    async function showChargebeeSubsciptions() {
        try {
            await showChargebeeSection(props, "SUBSCRIPTION_DETAILS");
        } catch (e) {
            setChargebeeErrorMessage(e.message);
        }
    }

    return (
        <Card className="modules-card col">
            <div className="modules-card-header flex justify-between">
                <span className="modules-card-title">
                    {i18n.t("subscriptions.my-modules")}
                </span>
                {showChargeBeeUi(props) && (
                    <div
                        className={`${styles.link} no-link`}
                        onClick={showChargebeeSubsciptions}
                    >
                        {i18n.t("subscriptions.manage-subscriptions")}
                    </div>
                )}
                {chargebeeErrorMessage && (
                    <FlashMessage
                        message={chargebeeErrorMessage}
                        type="danger"
                        hasClosed={() => setChargebeeErrorMessage(null)}
                    />
                )}

                {/*<span onClick={() => setModulesModal(true)} className="edit-modules">{i18n.t("subscriptions.manage-subscriptions")}</span>*/}
            </div>
            <div className="modules-card-body">
                {props.displayableModules.active.map((module, index) => {
                    return (
                        <Module
                            module={module}
                            key={index}
                            isOrgModule={true}
                            statusName={statusNames[module.status || -1]}
                            dispatch={dispatch}
                        />
                    );
                })}
                {props.displayableModules.inactive.map((module, index) => {
                    // Do not show Safety at all if it is not active
                    if (module.id === 21) {
                        return "";
                    }
                    return (
                        <Module
                            module={module}
                            key={index}
                            isOrgModule={false}
                            state={state}
                            dispatch={dispatch}
                        />
                    );
                })}
            </div>
        </Card>
    );
}
